import { Heading, Badge, Stack } from "@chakra-ui/react";
import { OrganizationUnit } from "brokertslib/src/dtos";
import { ChevronRight } from "../../icons";
import { OrganizationLink } from "../shared/OrganizationLink";

export const OrganizationDetailHeading = ({ id, name, superiorOrganizationUnitName, superiorOrganizationUnitId }: OrganizationUnit) => {
    return <Stack direction='column' alignItems={'start'}>
        <Stack direction='row' sx={{ gap: 4, alignItems: 'center' }}>
            {superiorOrganizationUnitName && <>
                <Heading as="h1"><OrganizationLink id={superiorOrganizationUnitId} name={superiorOrganizationUnitName} /></Heading>
                <ChevronRight />
            </>}
            <Heading as="h1">{name}</Heading>
        </Stack>
        <Badge colorScheme="gray" variant='outline'>ID: {id}</Badge>
    </Stack>
}